import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'dva'
import dayjs from 'dayjs'
import { COLORS, FEATURE_TYPES } from '../../lib/constants'
import { formatDate, getColor } from '../../lib/utils'
import AreaIcon from '../../assets/svg/AreaIcon'
import Checkbox from '../Form/Checkbox'
import Eyecon from '../Form/Eyecon'
import Group from '../../assets/svg/Remix/Group'
import LineIcon from '../../assets/svg/LineIcon'
import styles from './FeatureListItem.module.scss'
import TracksIcon from '../../assets/svg/TracksIcon'
import WaypointIcon from '../../assets/svg/WaypointIcon'
import ghAnalytics from '../../lib/analytics';

function FeatureListItem(props) {
  const [isSelected, setIsSelected] = useState(props.isSelected)
  const [isVisible, setIsVisible] = useState(props.isVisible)

	useEffect(() => {
		setIsSelected(props.isSelected)
	}, [props.isSelected])

	useEffect(() => {
		setIsVisible(props.isVisible)
	}, [props.isVisible])

	const Icon = () => {
		if (props.feature && props.feature.properties) {
			if (props.feature.properties.ghType === FEATURE_TYPES.Polyline) {
				return <LineIcon width={18} color={getColor(props.feature)} />
			} else if (props.feature.properties.ghType === FEATURE_TYPES.Polygon) {
				return <AreaIcon width={18} color={getColor(props.feature)} />
			} else if (props.feature.properties.ghType === FEATURE_TYPES.Tracks) {
				return <TracksIcon width={18} color={getColor(props.feature)} />
			} else {
				return <WaypointIcon icon={props.feature.properties.icon} color={getColor(props.feature)} width={18} />
			}
		}
	}

  const toggleVisibility = (visibility) => {
		if (props.showVisibilityIcon) {
			setIsVisible(visibility)
			props.dispatch({
				type: 'features/setFeaturesVisibility',
				payload: { featureId: props.feature.uuid, visibility, type: 'feature' }
			});
			ghAnalytics.logVisibility(visibility, props.feature);
		}
  }

	const toggleCheckbox = () => {
    setIsSelected(!isSelected)
		let actionType = null
		if (!isSelected) {
			actionType = 'features/addToSelectedFeatures'
		} else {
			actionType = 'features/removeFromSelectedFeatures'
		}
		props.dispatch({
			type: actionType,
			payload: {
				type: 'single',
				featureIds: [props.feature.uuid],
			},
		})
	}

	return (
		<li id={props.feature.uuid} onClick={props.onClick} className={styles.featureItem}>
			<div className={styles.featureInfo}>
				{
					<div className={isSelected ? styles.checkboxOnContainer : styles.checkboxContainer} onClick={(e) => e.stopPropagation()}>
						<span className={styles.icon}>
							<Icon />
						</span>
						<span className={styles.checkbox}>
							<Checkbox checked={isSelected} disabled={props.isDisabled} id={`checkbox-${props.feature.uuid}`} onChange={() => toggleCheckbox()} />
						</span>
					</div>
				}
				<div className={styles.featureDetails}>
					<div className={styles.featureTitle}>
						<h1>{props.feature.title}</h1>
					</div>
					<div className={styles.featureDate}>{formatDate(props.feature.properties && props.feature.properties.createdAt ? props.feature.properties.createdAt * 1000 : dayjs().unix())}</div>
				</div>
			</div>
			<div className={styles.featureVisibility} onClick={(e) => e.stopPropagation()}>
				{props.feature.isOwner === false ? <Group color={COLORS.ghGreyLtText} width={24} /> : null}
				{props.showVisibilityIcon ? <Eyecon isOn={isVisible} onChange={(visibility) => toggleVisibility(visibility)} /> : null}
			</div>
		</li>
	)
}

FeatureListItem.propTypes = {
	feature: PropTypes.object,
	isDisabled: PropTypes.bool,
	isEditingFeature: PropTypes.bool,
	isSelected: PropTypes.bool,
	isVisible: PropTypes.bool,
	selectedFeatures: PropTypes.array,
	showVisibilityIcon: PropTypes.bool,
	// actions
	onClick: PropTypes.func,
}

FeatureListItem.defaultProps = {
	showVisibilityIcon: true,
}

export default connect((model, currentProps) => {
	const { feature } = currentProps
	const { isEditingFeature, selectedFeatures } = model.features
	const isSelected = selectedFeatures.includes(feature.uuid)
	return {
		isSelected,
		isEditingFeature,
	}
})(FeatureListItem)
